import { useEffect, useState } from "react";
import { api, errorMessage } from "../lib/api";

export const BookingVenueStep = ({ onChoose }) => {
  const [query, setQuery] = useState("");
  const [venues, setVenues] = useState([]);
  const [error, setError] = useState("");
  useEffect(() => {
    let live = true;
    const timer = setTimeout(() => api.get("/venues", { params: { view: "tutti", q: query } })
      .then(({ data }) => { if (live) { setVenues(data.items); setError(""); } })
      .catch((e) => { if (live) setError(errorMessage(e)); }), 180);
    return () => { live = false; clearTimeout(timer); };
  }, [query]);
  const bookableVenues = venues.filter((venue) => !venue.archived_at &&
    !["Cliente", "Firmato", "Perso", "Irraggiungibile", "Non interessato", "Non in target"].includes(venue.status));
  return <div className="booking-step" data-testid="booking-venue-step">
    <div className="form-field"><label htmlFor="booking-venue-search">LOCALE</label><input id="booking-venue-search" type="search" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Scrivi il nome" data-testid="booking-venue-search" /></div>
    {error && <p role="alert" className="form-error" data-testid="booking-venue-error">{error}</p>}
    <div className="agenda-venue-options" data-testid="booking-venue-options">
      {bookableVenues.map((venue) =>
        <button type="button" key={venue.id} onClick={() => onChoose(venue)} data-testid={`booking-choose-venue-${venue.id}`}>
          <strong>{venue.name}</strong><span>{venue.status} ›</span>
        </button>)}
      {!bookableVenues.length && !error && <p className="venue-list-empty" data-testid="booking-venues-empty">Nessun locale disponibile.</p>}
    </div>
  </div>;
};